import React, { useState } from 'react';
import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Route, Router, Routes } from 'react-router-dom';
import AdminLogin from './Admin/AdminLogin';
import AdminHeader from './Admin/AdminMaster/AdminHeader';
import AdminDashboard from './Admin/AdminMaster/AdminDashboard';
import DailyStock from './Admin/AdminMaster/AdminOrderDS/DailyStock';
import OrderAllotment from './Admin/AdminMaster/AdminOrderDS/OrderAllotment';
import OrderBoyToCusAllotment from './Admin/AdminMaster/AdminOrderDS/OrderBoyToCusAllotment';
import CustomerMaster from './Admin/AdminMaster/AdminMasters/CustomerMaster';
import ProductMaster from './Admin/AdminMaster/AdminMasters/ProductMaster';
import DeliveryBoy from './Admin/AdminMaster/AdminMasters/DeliveryBoy';
import AdminBilling from './Admin/AdminMaster/AdminBilling';

import DeliveryLogin from './Delivery/DeliveryLogin';
import DeliveryDashboard from './Delivery/DeliveryDashboard';
import DeliveryHeader from './Delivery/DeliveryHeader';
import DeliveryList from './Delivery/DeliveryList';
import AdminBillPrint from './Admin/AdminMaster/AdminBillPrint';
import AdminPayment from './Admin/AdminMaster/AdminPayment';
import ChangePassword from './ChangePassword';
import DeliveryNav from './Delivery/DeliveryNav';
import DeliveryChangePass from './Delivery/DeliveryChangePass';
import AdminNavBar from './AdminComponent/AdminNavBar';
import AdminDashboard1 from './AdminComponent/AdminDashboard1';
import ProductMaster1 from './AdminComponent/ProductMaster1';
import CustomerMaster1 from './AdminComponent/CustomerMaster1';
import EmployeeMaster1 from './AdminComponent/EmployeeMaster1';
import EmpToCustAllotment from './AdminComponent/EmpToCustAllotment';
import OrderAllotment1 from './AdminComponent/OrderAllotment1';
import DailyStock1 from './AdminComponent/DailyStock1';
import BillingProcess1 from './AdminComponent/BillingProcess1';
import Payment1 from './AdminComponent/Payment1';
import ChangePassword1 from './AdminComponent/ChangePassword1';
import NavLogo from './AdminComponent/NavLogo';
import ReturnStock from './AdminComponent/ReturnStock';
import ReportDailyStock from './AdminComponent/Report/ReportDailyStock';
import ReportNavbar from './AdminComponent/Report/ReportNavbar';
import ReportReturnStock from './AdminComponent/Report/ReportReturnStock';
import ReportGenerateBill from './AdminComponent/Report/ReportGenerateBill';
import ReportPendingBill from './AdminComponent/Report/ReportPendingBill';
import ReportPaymentRec from './AdminComponent/Report/ReportPaymentRec';
import ReportPaymentPending from './AdminComponent/Report/ReportPaymentPending';
import Expense from './AdminComponent/Expense';
import ReportExpense from './AdminComponent/Report/ReportExpense';
import ReportDashboard from './AdminComponent/Report/ReportDashboard';

function App() {
  return (
   <>
      <Routes>
        <Route path="/" element={<AdminLogin />}/>
        <Route path="/adminHeader" element={<AdminHeader />}/>
        <Route path="/adminDashboard" element={<AdminDashboard />}/>
        <Route path="/dailyStock" element={<DailyStock />}/>
        <Route path="/orderAllotment" element={<OrderAllotment />}/>
        <Route path="/orderBoyToCustomer" element={<OrderBoyToCusAllotment />}/>
        <Route path="/customerMaster" element={<CustomerMaster />}/>
        <Route path="/productMaster" element={<ProductMaster />}/>
        <Route path="/deliveryBoy" element={<DeliveryBoy />}/>
        <Route path="/adminBilling" element={<AdminBilling />}/>
        <Route path="/adminBillPrint" element={<AdminBillPrint />}/>
        <Route path="/payment" element={<AdminPayment />}/>

        {/* ============ New ====================== */}

        <Route path="/adminNavbar" element={<AdminNavBar />}/>
        <Route path="/adminDashboard1" element={<AdminDashboard1 />}/>
        <Route path="/productMaster1" element={<ProductMaster1 />}/>
        <Route path="/customerMaster1" element={<CustomerMaster1 />}/>
        <Route path="/employeeMaster1" element={<EmployeeMaster1 />}/>
        <Route path="/empToCustAllotment" element={<EmpToCustAllotment />}/>
        <Route path="/orderAllotment1" element={<OrderAllotment1 />}/>
        <Route path="/dailyStock1" element={<DailyStock1 />}/>
        <Route path="/billingProcess1" element={<BillingProcess1 />}/>
        <Route path="/payment1" element={<Payment1 />}/>
        <Route path="/passwordChange" element={<ChangePassword1 />}/>
        <Route path="/navLogo" element={<NavLogo />}/>
        <Route path="/returnStock" element={<ReturnStock />}/>
        <Route path="/deliveryStockReport" element={<ReportDailyStock />}/>
        <Route path="/navbarReport" element={<ReportNavbar />}/>
        <Route path="/dashboardReport" element={<ReportDashboard />}/>
        <Route path="/returnStockReport" element={<ReportReturnStock />}/>
        <Route path="/generateBillReport" element={<ReportGenerateBill />}/>
        <Route path="/pendingBillReport" element={<ReportPendingBill />}/>
        <Route path="/paymentRecReport" element={<ReportPaymentRec />}/>
        <Route path="/paymentPenReport" element={<ReportPaymentPending />}/>
        <Route path="/expense" element={<Expense />}/>
        <Route path="/expenseReport" element={<ReportExpense />}/>






        <Route path="/deliveryLogin" element={<DeliveryLogin />}/>
        <Route path="/deliveryDashboard" element={<DeliveryDashboard />}/>
        <Route path="/deliveryHeader" element={<DeliveryHeader />}/>
        <Route path="/productDelivery" element={<DeliveryList />}/>
        <Route path="/passwordChange" element={<ChangePassword />}/>
        <Route path="/deliveryNav" element={<DeliveryNav />}/>
        <Route path="/passChangeDelivery" element={<DeliveryChangePass />}/>
      </Routes>
   </>
  );
}

export default App;
